export default {
  parking_lot: (state) => {
    return state.parking_lot[0];
  }
}
